import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import moment from "moment";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import LazyImage from "../../../../Utility/Components/LazyImageComponent";
import SkeletonThemeContentGroupList from "../../../../Utility/Components/SkeletonThemeContentGroupList";
import Utility from "../../../../Utility/Utility";
import GroupPackageSearchPanel from "../Components/GroupPackageSearchPanel";
import BreadcrumbMenu from "../../../../Utility/Components/BreadcrumbMenu";

import { getGroupTourApi } from "../../../../GlobalModules/Login/Controller/LoginController";
import { getTourTagCount, getTagWiseCount } from "../Controller/HomeController"
import {
    loaderStateTrue,
    loaderStateFalse,
    tourSearchData,
    groupTourPackageSearchData,
} from "../../../../../src/Actions/AllAction";

import "../../../../Utility/Public/css/common.scss";
import "../Assets/css/homedoc.scss";
import "../Assets/css/homeresponsivedoc.scss";
import "../Assets/css/tour-list-modern.scss";

const FALLBACK_IMAGE = require("../../../../Utility/Public/images/stateLoaderImage.png");

const TRAVEL_CLUB_TABS = [
    { id: "all", label: "All Travel Club" },
    { id: "solo", label: "Solo" },
    { id: "grand", label: "Grand" },
    { id: "family", label: "Family" },
];

const safeTrim = (val) => {
    if (val == null) return "";
    if (typeof val === "string") return val.trim();
    if (typeof val === "number" || typeof val === "boolean") return String(val).trim();
    if (typeof val === "object") {
        if (typeof val.label === "string" && val.label.trim()) return val.label.trim();
        if (typeof val.value === "string") return val.value.trim();
        if (typeof val.value === "number") return String(val.value).trim();
        if (typeof val.label === "number") return String(val.label).trim();
        return "";
    }
    return "";
};

const DepartureModalSkeleton = () => (
    <SkeletonTheme baseColor="#f3f3f3" highlightColor="#ebebeb">
        <div className="departure-skeleton-list">
            {Array.from({ length: 5 }).map((_, i) => (
                <div className="departure-skeleton-row" key={i}>
                    <Skeleton circle width={18} height={18} />
                    <div className="departure-skeleton-info">
                        <Skeleton width="70%" height={13} />
                        <Skeleton width="45%" height={10} style={{ marginTop: 6 }} />
                    </div>
                    <div className="departure-skeleton-price">
                        <Skeleton width={60} height={13} />
                        <Skeleton width={40} height={9} style={{ marginTop: 6 }} />
                    </div>
                    <Skeleton width={70} height={20} borderRadius={999} />
                </div>
            ))}
        </div>
    </SkeletonTheme>
);

const TourCardSkeleton = () => {
    const count = 8;
    return (
        <SkeletonTheme baseColor="#f3f3f3" highlightColor="#ebebeb">
            <div className="modern-tour-grid">
                {Array.from({ length: count }).map((_, i) => (
                    <article className="modern-tour-card tour-card-skeleton" key={i}>
                        <div className="tour-card-image skeleton-image">
                            <Skeleton width="100%" height="100%" />
                        </div>

                        <div className="tour-card-body">
                            <div className="tour-card-heading">
                                <Skeleton width="80%" height={16} />
                                <div className="tour-rating-row">
                                    <Skeleton width={60} height={12} style={{ marginTop: 8 }} />
                                </div>
                            </div>

                            <div className="tour-feature-row">
                                <Skeleton width={70} height={10} />
                                <Skeleton width={70} height={10} />
                                <Skeleton width={70} height={10} />
                            </div>

                            <div className="tour-card-bottom">
                                <div className="tour-next-date">
                                    <Skeleton width={90} height={10} style={{ marginBottom: 6 }} />
                                    <Skeleton width={110} height={12} />
                                </div>
                                <div className="tour-price">
                                    <Skeleton width={70} height={10} style={{ marginBottom: 4 }} />
                                    <Skeleton width={80} height={18} />
                                </div>
                            </div>

                            <div className="tour-card-actions single-action">
                                <Skeleton width="100%" height={41} borderRadius={7} />
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </SkeletonTheme>
    );
};

const TourList = (props) => {
    const history = useHistory();
    const location = useLocation();

    const isTravelClub = new URLSearchParams(location.search).get("travel_club") === "1";

    const itemsPerPage = 9;

    const [currentPage, setCurrentPage] = useState(1);
    const [groupTourState, setGroupTourState] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [apiCallFinish, setApiCallFinish] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [selectedDepartures, setSelectedDepartures] = useState({});
    const [departureModalTour, setDepartureModalTour] = useState(null);
    const [modalSelectedDepartureId, setModalSelectedDepartureId] = useState(null);
    const [modalDepartures, setModalDepartures] = useState([]);
    const [isLoadingDepartures, setIsLoadingDepartures] = useState(false);

    const [sortBy, setSortBy] = useState("recommended");
    const [viewMode, setViewMode] = useState("grid");
    // Tour category navigation (independent of the existing search and tour cards)
    const tourTabsRef = useRef(null);
    const tabDragRef = useRef({ active: false, startX: 0, startScroll: 0, moved: false });
    const suppressTabClickRef = useRef(false);
    const [isDraggingTabs, setIsDraggingTabs] = useState(false);
    const [activeTourType, setActiveTourType] = useState(() => {
        const homeSelected = Array.isArray(props.userHotelGroupPackageSelectedData)
            ? (props.userHotelGroupPackageSelectedData.find(item => item.isSelected)?.value || '')
            : '';
        const urlType = new URLSearchParams(location.search).get("tour_type") || "";
        const effective = (["group_package_tour", "customized_tour", "fixed_departure_group_tour"].includes(homeSelected) ? homeSelected : '') || urlType;
        if (isTravelClub) return 'group';
        if (new URLSearchParams(location.search).get("fixed_departure") === "1") return 'group';
        if (["customized_tour", "customized"].includes(effective)) return 'customized';
        if (["fixed_departure_group_tour", "group"].includes(effective)) return 'group';
        return 'package';
    });

    const startTabDrag = (event) => {
        if (event.button !== 0 || !tourTabsRef.current) return;
        tabDragRef.current = {
            active: true,
            startX: event.clientX,
            startScroll: tourTabsRef.current.scrollLeft,
            moved: false,
        };
        setIsDraggingTabs(true);
    };

    const moveTabDrag = (event) => {
        const drag = tabDragRef.current;
        if (!drag.active || !tourTabsRef.current) return;
        const distance = event.clientX - drag.startX;
        if (Math.abs(distance) > 5) drag.moved = true;
        if (drag.moved) {
            tourTabsRef.current.scrollLeft = drag.startScroll - distance;
        }
    };

    const endTabDrag = () => {
        if (!tabDragRef.current.active) return;
        suppressTabClickRef.current = tabDragRef.current.moved;
        tabDragRef.current.active = false;
        setIsDraggingTabs(false);
    };

    const handleTabClickCapture = (event) => {
        if (suppressTabClickRef.current) {
            event.preventDefault();
            event.stopPropagation();
            suppressTabClickRef.current = false;
        }
    };
    const [activeTourTab, setActiveTourTab] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        const type = params.get("tour_type");
        return type === "customized_tour" ? "customized" : "all";
    });

    const [tourTabCountWise, setTourTabCountWise] = useState(
        isTravelClub ? TRAVEL_CLUB_TABS : [{ id: "all", label: "All Packages" }]
    );
    const activeTourTabRef = useRef(activeTourTab);
    activeTourTabRef.current = activeTourTab;

    const tourTabs = {
        "Domestic": [
            { id: "all", label: "All Packages" },
            { id: "north_india", label: "North India" },
            { id: "central_india", label: "Central India" },
            { id: "west_india", label: "West India" },
            { id: "south_india", label: "South India" },
            { id: "east_india", label: "East India" },
            { id: "north_east_india", label: "North East India" },
            { id: "andaman", label: "Andaman" },
            { id: "lakshwadweep", label: "lakshwadweep" }
        ],
        "International": [
            { id: "all", label: "All Packages" },
            { id: "europe", label: "Europe" },
            { id: "america", label: "America" },
            { id: "cis", label: "CIS" },
            { id: "middle_east_asia", label: "Middle east asia" },
            { id: "south_east_asia", label: "South East Asia" },
            { id: "india_and_it_s_neighbour", label: "India and it's neighbour" },
            { id: "australia_newzealand", label: "Australia & Newzealand" },
            { id: "africa", label: "Africa" },
        ],
        "Sweet Bengal": [
            { id: "all", label: "All Packages" },
            { id: "darjiling_kalimpong_hills", label: "Darjiling & kalimpong Hills" },
            { id: "dooars", label: "Dooars" },
            { id: "maldah_dinazpur", label: "Maldah Dinazpur" },
            { id: "murshidabad", label: "Murshidabad" },
            { id: "jhargram", label: "Jhargram" },
            { id: "rarhbanga_purulia_bankur_west_medinipur", label: "Rarhbanga- Purulia, Bankura, West Medinipur" },
            { id: "sunderban", label: "Sunderban" },
            { id: "east_medinipur", label: "East Medinipur" },
            { id: "nadia", label: "Nadia" },
            { id: "birbhum", label: "Birbhum" },
            { id: "bardhaman_hoogly", label: "Bardhaman-Hoogly" },
        ]
    };
    const selectTourTab = (tabId) => {
        setActiveTourTab(tabId);
        setCurrentPage(1);
        const params = new URLSearchParams(location.search);
        params.delete("page");
        params.delete("tour_type");
        // Only these types are supported by the existing API mapping.
        if (tabId === "group") params.set("tour_type", "fixed_departure_group_tour");
        if (tabId === "customized") params.set("tour_type", "customized_tour");
        history.push(`${location.pathname}${params.toString() ? `?${params.toString()}` : ""}`);
    };
    const scrollTourTabs = (direction) => {
        tourTabsRef.current?.scrollBy({ left: direction * 320, behavior: "smooth" });
    };


    const [selectedDestination, setSelectedDestination] = useState(
        () => localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || ''
    );
    const [selectedTheme, setSelectedTheme] = useState(
        () => localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || ''
    );
    const [selectedNavTag, setSelectedNavTag] = useState(
        () => localStorage.getItem('selectedNavTag') || props.selectedNavTagFromReducer || ''
    );
    const [searchResetKey, setSearchResetKey] = useState(0);

    const [selectedTourTag, setSelectedTourTag] = useState(() => {
        const dest = localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || '';
        const theme = localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || '';
        const nav = localStorage.getItem('selectedNavTag') || props.selectedNavTagFromReducer || '';
        const search = window.location.search;
        const urlTag = new URLSearchParams(search).get("tag") || new URLSearchParams(search).get("tags") || new URLSearchParams(search).get("city") || "";
        return dest || theme || nav || urlTag;
    });

    useEffect(() => {
        if (props.selectedNavTagFromReducer !== undefined && props.selectedNavTagFromReducer !== selectedNavTag) {
            setSelectedNavTag(props.selectedNavTagFromReducer || '');
        }
    }, [props.selectedNavTagFromReducer]);

    useEffect(() => {
        const urlTag = new URLSearchParams(location.search).get("tag") || new URLSearchParams(location.search).get("tags") || new URLSearchParams(location.search).get("city") || "";
        setSelectedTourTag(selectedDestination || selectedTheme || selectedNavTag || urlTag);
    }, [selectedDestination, selectedTheme, selectedNavTag, location.search]);

    useEffect(() => {
        const handleSelectionChange = (e) => {
            setSelectedDestination(localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || '');
            setSelectedTheme(localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || '');
            const navTag = e?.detail?.type === 'navTag' ? (e.detail.option || '') : (localStorage.getItem('selectedNavTag') || '');
            setSelectedNavTag(navTag);
            if (props.groupTourPackageSearchData) {
                props.groupTourPackageSearchData();
            }
            setActiveTourType('package');
            setSearchResetKey(k => k + 1);
        };
        window.addEventListener('sectionSelectionChange', handleSelectionChange);
        return () => {
            window.removeEventListener('sectionSelectionChange', handleSelectionChange);
        };
    }, []);

    useEffect(() => {
        const dest = localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || '';
        const theme = localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || '';
        const nav = localStorage.getItem('selectedNavTag') || sessionStorage.getItem('selectedNavTag') || '';

        const count = (dest ? 1 : 0) + (theme ? 1 : 0) + (nav ? 1 : 0);
        if (count > 1) {
            if (dest) {
                setSelectedTheme('');
                setSelectedNavTag('');
                localStorage.removeItem('selectedTheme');
                if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem('selectedTheme');
                localStorage.removeItem('selectedNavTag');
                if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem('selectedNavTag');
            } else if (theme) {
                setSelectedNavTag('');
                localStorage.removeItem('selectedNavTag');
                if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem('selectedNavTag');
            }
        }
    }, []);

    const initialLoadRef = useRef(true);
    const urlProcessedRef = useRef(false);
    const lastFetchRef = useRef(null);
    const isTagInitialMount = useRef(true);

    const totalPages = Math.max(1, Math.ceil(totalRecords / itemsPerPage));

    /* -------------------------------------------------------------------------- */
    /* Helpers                                                                    */
    /* -------------------------------------------------------------------------- */

    const getTourKey = (tour) =>
        String(
            tour?.tour_id ||
            tour?.id ||
            tour?.tour_code
        );

    const isPastDeparture = (departure) => {
        if (!departure?.start_date) return false;
        return moment(departure.start_date).isBefore(moment().startOf("day"), "day");
    };

    const getValidDepartures = (tour) => {
        const list = Array.isArray(tour?.departures) ? tour.departures : [];

        return list
            .filter((departure) => departure?.start_date && departure?.end_date)
            .sort(
                (a, b) =>
                    moment(a.start_date, "YYYY-MM-DD").valueOf() -
                    moment(b.start_date, "YYYY-MM-DD").valueOf()
            );
    };

    const getSelectedDeparture = (tour) => {
        const departures = getValidDepartures(tour);
        if (!departures.length) return tour;

        const tourKey = getTourKey(tour);
        const selectedId = selectedDepartures[tourKey];

        return (
            departures.find(
                (departure) =>
                    String(departure.id) === String(selectedId) ||
                    String(departure.tour_code) === String(selectedId)
            ) || departures[0]
        );
    };

    const getTourImage = (tour) => {
        if (tour?.thumbnail_path) return tour.thumbnail_path;

        const media = Array.isArray(tour?.Media) ? tour.Media : [];
        if (media.length && media[0]?.file_url) {
            try {
                const parsed = JSON.parse(media[0].file_url);

                if (Array.isArray(parsed) && parsed.length) {
                    return parsed[0]?.file_url || parsed[0]?.file_obj || FALLBACK_IMAGE;
                }

                if (parsed?.file_url || parsed?.file_obj) {
                    return parsed.file_url || parsed.file_obj;
                }
            } catch (error) {
                if (
                    typeof media[0].file_url === "string" &&
                    media[0].file_url.startsWith("http")
                ) {
                    return media[0].file_url;
                }
            }
        }

        try {
            const destinationImage = tour?.DestinationTo?.image_url;
            if (destinationImage) {
                const parsed = JSON.parse(destinationImage);
                return parsed?.file_obj || parsed?.file_url || FALLBACK_IMAGE;
            }
        } catch (error) {
            // no-op
        }

        return FALLBACK_IMAGE;
    };

    const getCurrency = (tour) =>
        tour?.branch_details?.currency || tour?.base_currency || "INR";

    const getPrice = (tour) => {
        const departure = getSelectedDeparture(tour);

        return (
            departure?.price_for_adult ||
            tour?.price_for_adult ||
            departure?.final_selling_price ||
            tour?.final_selling_price ||
            0
        );
    };

    const formatPrice = (tour) => {
        const symbol = Utility.getCurrencySymbol(getCurrency(tour));
        const amount = Number(getPrice(tour) || 0);

        return `${symbol}${amount.toLocaleString("en-IN", {
            maximumFractionDigits: 0,
        })}`;
    };

    const getDuration = (tour) => {
        const departure = getSelectedDeparture(tour);

        if (departure?.duration) return departure.duration;
        if (tour?.duration) return tour.duration;

        const nights = departure?.duration_nights ?? tour?.duration_nights;
        const days = departure?.duration_days ?? tour?.duration_days;

        if (nights != null || days != null) {
            return `${nights || 0}N / ${days || 0}D`;
        }

        return "Tour";
    };

    const normalizeFeatures = (tour) => {
        const inclusions = Array.isArray(tour?.inclusions)
            ? tour.inclusions
            : Array.isArray(tour?.Inclusions)
                ? tour.Inclusions
                : [];

        const text = inclusions
            .map((item) =>
                typeof item === "string" ? item : item?.inclusion_text || ""
            )
            .join(" ")
            .toLowerCase();

        const itineraryText = JSON.stringify(
            tour?.Itineraries || tour?.itinerary_json || []
        ).toLowerCase();

        return [
            {
                icon: "fa-users",
                label:
                    String(tour?.tour_type || "").toLowerCase() === "package"
                        ? "Package Tour"
                        : "Group Tour",
            },
            {
                icon: "fa-cutlery",
                label: text.includes("breakfast") || text.includes("meal") ? "Meals" : "Meals",
            },
            {
                icon: "fa-bus",
                label:
                    text.includes("transport") ||
                        itineraryText.includes("transfer") ||
                        itineraryText.includes("flight")
                        ? "Transport"
                        : "Transport",
            },
            {
                icon: "fa-camera",
                label:
                    itineraryText.includes("activity") ||
                        itineraryText.includes("visit") ||
                        itineraryText.includes("sightseeing")
                        ? "Sightseeing"
                        : "Sightseeing",
            },
        ];
    };

    const getAvailability = (departure) => {
        if (!departure) {
            return { label: "Available", className: "available" };
        }

        if (departure.is_sold_out) {
            return { label: "Sold out", className: "sold-out" };
        }

        const seats = Number(departure.remaining_guest_count);
        if (departure.is_filling_fast) {
            return {
                label: seats > 0 ? `Only ${seats} seats left` : "Filling fast",
                className: "filling-fast",
            };
        }

        if (Number.isFinite(seats) && seats > 0 && seats <= 5) {
            return {
                label: `Only ${seats} seats left`,
                className: "low-stock",
            };
        }

        return { label: "Available", className: "available" };
    };

    /* -------------------------------------------------------------------------- */
    /* URL                                                                        */
    /* -------------------------------------------------------------------------- */

    const buildTourUrlParams = (
        searchData = props.userGroupTourPackageSearchData || {},
        page = currentPage
    ) => {
        const searchParams = new URLSearchParams(location.search);

        const currentDestination = localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || selectedDestination || '';
        const currentTheme = localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || selectedTheme || '';
        const currentNavTag = selectedNavTag || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('selectedNavTag') : '') || '';
        const activeTag = currentDestination || currentTheme || currentNavTag || '';
        const activeTagKey = activeTag ? Utility.getTagByKey(activeTag) : '';
        const tagParam = searchParams.get("tag") || searchParams.get("tags") || activeTagKey;

        if (tagParam) {
            searchParams.set("tag", tagParam);
            searchParams.delete("tags");
        } else {
            searchParams.delete("tag");
            searchParams.delete("tags");
        }

        const tourType = searchParams.get("tour_type");
        if (tourType) {
            searchParams.set("tour_type", tourType);
        } else {
            searchParams.delete("tour_type");
        }

        searchParams.delete("from");
        searchParams.delete("to");

        const searchVal = safeTrim(searchData.search);
        if (searchVal) {
            searchParams.set("search", searchVal);
        } else {
            searchParams.delete("search");
        }

        if (searchData.start_date) {
            searchParams.set(
                "start_date",
                moment(searchData.start_date).format("YYYY-MM-DD")
            );
        } else {
            searchParams.delete("start_date");
        }

        if (searchData.end_date) {
            searchParams.set(
                "end_date",
                moment(searchData.end_date).format("YYYY-MM-DD")
            );
        } else {
            searchParams.delete("end_date");
        }

        if (page > 1) {
            searchParams.set("page", String(page));
        } else {
            searchParams.delete("page");
        }

        return searchParams.toString();
    };

    const updateUrl = (page = currentPage, freshData = null) => {
        const params = buildTourUrlParams(
            freshData || props.userGroupTourPackageSearchData || {},
            page
        );
        const nextUrl = `${history.location.pathname}${params ? `?${params}` : ""}`;

        if (`${location.pathname}${location.search}` !== nextUrl) {
            history.replace(nextUrl);
        }
    };

    const parseUrlParams = () => {
        if (urlProcessedRef.current) return;

        const searchParams = new URLSearchParams(location.search);

        if (searchParams.has("from") || searchParams.has("to")) {
            searchParams.delete("from");
            searchParams.delete("to");
            const cleanUrl = `${location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
            if (cleanUrl !== `${location.pathname}${location.search}`) {
                history.replace(cleanUrl);
            }
        }

        const from = searchParams.get("from");
        const to = searchParams.get("to");
        const search = searchParams.get("search");
        const destination = searchParams.get("destination");
        const startDate = searchParams.get("start_date");
        const endDate = searchParams.get("end_date");
        const tourType = searchParams.get("tour_type");
        const page = Number(searchParams.get("page") || 1);

        const nextSearchData = {
            ...(props.userGroupTourPackageSearchData || {}),
        };

        let changed = false;

        if (tourType) {
            nextSearchData.tour_type = tourType;
            changed = true;
        } else if (nextSearchData.tour_type) {
            delete nextSearchData.tour_type;
            changed = true;
        }

        if (from && isNaN(from)) {
            nextSearchData.starting_from = { value: from, label: from };
            changed = true;
        }

        if (to && isNaN(to)) {
            nextSearchData.going_to = { value: to, label: to };
            changed = true;
        }

        if (search) {
            nextSearchData.search = search;
            changed = true;
        } else if (nextSearchData.search) {
            nextSearchData.search = "";
            changed = true;
        }

        if (destination) {
            if (!nextSearchData.search && !search) {
                nextSearchData.search = destination;
            }
            if (!nextSearchData.starting_from && !from) {
                nextSearchData.starting_from = { value: destination, label: destination };
            }
            changed = true;
        }

        if (startDate) {
            nextSearchData.start_date = new Date(startDate);
            changed = true;
        }

        if (endDate) {
            nextSearchData.end_date = new Date(endDate);
            changed = true;
        }

        if (changed) {
            props.groupTourPackageSearchData(nextSearchData);
        }

        setCurrentPage(Number.isFinite(page) && page > 0 ? page : 1);
        urlProcessedRef.current = true;
    };

    /* -------------------------------------------------------------------------- */
    /* Group same package departures                                              */
    /* -------------------------------------------------------------------------- */
    const tourListTopRef = useRef(null);
    const groupToursData = (tours) => {
        if (!Array.isArray(tours)) return [];

        const groups = {};

        tours.forEach((tour) => {
            const groupKey = String(
                tour.parent_tour_detail_id ||
                tour.tour_series_group_code ||
                tour.id
            );

            if (!groups[groupKey]) {
                groups[groupKey] = {
                    tourInfo: tour,
                    departures: [],
                };
            }

            const isParent =
                tour.is_parent_tour === true ||
                String(tour.is_parent_tour).toLowerCase() === "true" ||
                !tour.parent_tour_detail_id;

            if (isParent) {
                groups[groupKey].tourInfo = tour;
            }

            groups[groupKey].departures.push(tour);
        });

        return Object.values(groups).map((group) => ({
            ...group.tourInfo,
            departures: group.departures.sort((a, b) => {
                if (!a?.start_date) return 1;
                if (!b?.start_date) return -1;
                return moment(a.start_date).valueOf() - moment(b.start_date).valueOf();
            }),
        }));
    };

    /* -------------------------------------------------------------------------- */
    /* API                                                                        */
    /* -------------------------------------------------------------------------- */

    const getGroupTour = (page = 1, freshData = null) => {
        const searchData =
            freshData || props.userGroupTourPackageSearchData || {};

        const from = safeTrim(searchData.starting_from);
        const to = safeTrim(searchData.going_to);
        const search = safeTrim(searchData.search);
        const startDate = searchData.start_date
            ? moment(searchData.start_date).format("YYYY-MM-DD")
            : "";
        const endDate = searchData.end_date
            ? moment(searchData.end_date).format("YYYY-MM-DD")
            : "";
        if (!new URLSearchParams(location.search).get("tour_type") && searchData.tour_type) {
            delete searchData.tour_type;
        }
        const tourTypeParam = new URLSearchParams(location.search).get("tour_type") || "";
        const countryParam = searchData.country || new URLSearchParams(location.search).get("country") || "";
        const stateParam = searchData.destination_state || new URLSearchParams(location.search).get("state") || "";
        const tagParam = new URLSearchParams(location.search).get("tag") || new URLSearchParams(location.search).get("tags") || "";
        const cityParam = new URLSearchParams(location.search).get("city") || new URLSearchParams(location.search).get("destination") || "";

        const currentDestination = localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || selectedDestination || '';
        const currentTheme = localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || selectedTheme || '';
        const currentNavTag = selectedNavTag || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('selectedNavTag') : '') || '';
        const activeTag = isTravelClub ? '' : (currentDestination || currentTheme || currentNavTag || '');
        console.log("activeTag: ", activeTag);
        let tags = tagParam
            ? [tagParam]
            : (activeTag ? [Utility.getTagByKey(activeTag)] : []);

        if (activeTourTab !== "") {
            if (isTravelClub && activeTourTab === "all") {
                tags.push("travel_club");
            } else {
                tags.push(activeTourTab);
            }
        }

        const uniqueTags = [...new Set(tags)].filter(tag => tag !== "all");

        console.log("uniqueTags: ", uniqueTags);
        const fetchSignature = JSON.stringify({
            from,
            to,
            search,
            startDate,
            endDate,
            tourTypeParam,
            countryParam,
            stateParam,
            tagParam,
            cityParam,
            tags: uniqueTags,
            page,
        });

        // if (lastFetchRef.current === fetchSignature) {
        //     // alert();
        //     return;
        // }
        // lastFetchRef.current = fetchSignature;

        // let mappedTourType = "group,package";
        let mappedTourType = "";
        if (activeTourType === "package") {
            mappedTourType = "package";
        } else if (activeTourType === "group") {
            mappedTourType = "group";
        }
        else if (activeTourType && !['hotel', 'homestay'].includes(activeTourType)) {
            mappedTourType = activeTourType;
        }

        console.log("search", searchData,);

        const filterHash = {
            offset: (page - 1) * itemsPerPage,
            limit: itemsPerPage,
        };
        if (mappedTourType !== "") {
            filterHash.tour_type = mappedTourType;
        }

        if (countryParam) {
            filterHash.destination_country = [countryParam];
        }

        if (stateParam) {
            filterHash.destination_state = [stateParam];
        }

        if (cityParam) {
            filterHash.destination_city = [cityParam];
        }

        if (from) {
            filterHash.location = from;
        }

        // if (to) {
        //     filterHash.to_location = to;
        // }

        if (search) {
            filterHash.search = search;
        }

        if (searchData.start_date) {
            filterHash.start_date = searchData.start_date
                ? moment(searchData.start_date).format("YYYY-MM-DD")
                : moment().add(1, 'days').format("YYYY-MM-DD");

            filterHash.end_date = searchData.end_date
                ? moment(searchData.end_date).format("YYYY-MM-DD")
                : moment().add(2, 'days').format("YYYY-MM-DD");
        }

        const scopeTag = uniqueTags.find(t => ["domestic", "international"].includes(t));
        const finalTags = uniqueTags.filter(t => t !== scopeTag);

        if (finalTags.length > 0) {
            filterHash.tags = finalTags;
        }

        if (scopeTag) {
            filterHash.tour_scope = scopeTag;
        }

        const filters = {
            filters: JSON.stringify(filterHash),
        };

        setIsLoading(true);
        props.loaderStateTrue(true);

        getGroupTourApi(filters)
            .then((response) => {
                if (response?.success) {
                    const rawData = Array.isArray(response.data) ? response.data : [];
                    setGroupTourState(rawData);

                    const total =
                        Number(response.total) ||
                        rawData.length;

                    setTotalRecords(total);
                } else {
                    setGroupTourState([]);
                    setTotalRecords(0);
                }

                setApiCallFinish(true);
            })
            .catch((error) => {
                console.error("Group tour API error:", error);
                setGroupTourState([]);
                setTotalRecords(0);
                setApiCallFinish(true);
            })
            .finally(() => {
                setIsLoading(false);
                props.loaderStateFalse(false);
            });
    };

    const callGetGroupTour = (page = 1, freshData = null) => {
        // console.log("Fresh Data----", freshData, page);
        // { "starting_from": { "label": "Krishnanagar", "value": "Krishnanagar" }, "going_to": null, "start_date": "2026-10-28T00:00:00.000Z", "end_date": "2026-10-30T00:00:00.000Z" }
        // return
        setCurrentPage(page);
        if (freshData) {
            const currentData = props.userGroupTourPackageSearchData || {};
            const normalizedData = { ...freshData };
            if (typeof normalizedData.starting_from === 'string' && normalizedData.starting_from.trim()) {
                normalizedData.starting_from = {
                    label: normalizedData.starting_from.trim(),
                    value: normalizedData.starting_from.trim()
                };
            }
            if (typeof normalizedData.going_to === 'string' && normalizedData.going_to.trim()) {
                normalizedData.going_to = {
                    label: normalizedData.going_to.trim(),
                    value: normalizedData.going_to.trim()
                };
            }
            props.groupTourPackageSearchData({ ...currentData, ...normalizedData });
        }
        updateUrl(page, freshData);
        handleGetTourTagCount(selectedTourTag, freshData, () => getGroupTour(page, freshData));
    };

    /* -------------------------------------------------------------------------- */
    /* Navigation                                                                 */
    /* -------------------------------------------------------------------------- */

    const goToTourDetails = (tour, forcedDeparture = null) => {
        const selectedDeparture = forcedDeparture || getSelectedDeparture(tour);

        const reducerData = props.tourSearchDataFromReducer || {};
        const tempSearchData = {
            ...reducerData,
            ...tour,
            ...selectedDeparture,
            departures: tour.departures || [],
        };

        props.tourSearchData(tempSearchData);

        const urlParams = buildTourUrlParams(
            props.userGroupTourPackageSearchData || {}
        );

        const tourCode = selectedDeparture?.tour_code || tour?.tour_code;
        const lang = localStorage.getItem("i18nextLng") || "en";
        window.scrollTo({ top: 0, behavior: "smooth" });
        console.log("bapan", `/${lang}/tour-details/${tourCode}`);
        // history.push(
        //     `/${lang}/tour-details/${tourCode}${urlParams ? `?${urlParams}` : ""}`
        // );
        history.push(
            `/${lang}/tour-details/${tourCode}${isTravelClub ? "?travel_club=1" : ""}`
        );
    };

    const scrollToTourListTop = () => {
        tourListTopRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    // Scroll to the top of the page when the Tour List page is opened or
    // navigated to (PUSH/POP). Internal history.replace() URL updates
    // (pagination, filter sync) are ignored so they don't fight the list scroll.
    const isFirstScrollToTop = useRef(true);
    useEffect(() => {
        if (isFirstScrollToTop.current) {
            isFirstScrollToTop.current = false;
            window.scrollTo(0, 0);
            return;
        }
        if (history.action !== "REPLACE") {
            window.scrollTo(0, 0);
        }
    }, [location]);
    const openDepartureModal = async (tour) => {
        const localDepartures = getValidDepartures(tour);
        const hasMultiple =
            Number(tour?.total_tour) > 1 || localDepartures.length > 1;

        if (!hasMultiple) {
            const departure = localDepartures[0];
            if (departure && !isPastDeparture(departure)) {
                goToTourDetails(tour, departure);
            }
            return;
        }

        const tourKey = getTourKey(tour);
        const previousSelected = selectedDepartures[tourKey];
        const currentSelected =
            previousSelected &&
                localDepartures.some(
                    (departure) =>
                        String(departure.id) === String(previousSelected) &&
                        !isPastDeparture(departure)
                )
                ? previousSelected
                : null;

        setDepartureModalTour(tour);
        setModalSelectedDepartureId(currentSelected);
        setModalDepartures([]);
        setIsLoadingDepartures(true);

        const filterHash = {
            tour_type: "group,package",
            tour_id: tour.tour_id
        };

        try {
            const response = await getGroupTourApi({
                filters: JSON.stringify(filterHash),
            });
            if (response?.success) {
                const rawData = Array.isArray(response.data) ? response.data : [];
                setModalDepartures(getValidDepartures({ departures: rawData }));
            } else {
                setModalDepartures(getValidDepartures({ departures: [tour] }));
            }
        } catch (error) {
            console.error("Error fetching tour departures:", error);
            setModalDepartures(getValidDepartures({ departures: [tour] }));
        } finally {
            setIsLoadingDepartures(false);
        }
    };

    const closeDepartureModal = () => {
        setDepartureModalTour(null);
        setModalSelectedDepartureId(null);
        setModalDepartures([]);
        setIsLoadingDepartures(false);
    };

    const continueWithSelectedDeparture = () => {
        if (!departureModalTour) return;

        const selected = modalDepartures.find(
            (departure) =>
                String(departure.id) === String(modalSelectedDepartureId) ||
                String(departure.tour_code) === String(modalSelectedDepartureId)
        );

        if (!selected || isPastDeparture(selected)) return;

        const tourKey = getTourKey(departureModalTour);

        setSelectedDepartures((previous) => ({
            ...previous,
            [tourKey]: selected.id || selected.tour_code,
        }));

        closeDepartureModal();
        goToTourDetails(departureModalTour, selected);
    };

    /* -------------------------------------------------------------------------- */
    /* Effects                                                                    */
    /* -------------------------------------------------------------------------- */

    useEffect(() => {
        parseUrlParams();

        const params = new URLSearchParams(location.search);
        const initialPage = Number(params.get("page") || 1);

        setCurrentPage(initialPage);
        if (!selectedTourTag) {
            getGroupTour(initialPage);
        }
        if (isTravelClub) {
            handleGetTourTagCount();
        }

        initialLoadRef.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const type = params.get("tour_type");
        if (params.get("travel_club") === "1") {
            setActiveTourType("group");
            setTourTabCountWise(TRAVEL_CLUB_TABS);
        }
        if (params.get("fixed_departure") === "1") {
            setActiveTourType("group");
        } else if (type === "fixed_departure_group_tour") {
            setActiveTourType("group");
        } else if (type === "customized_tour") {
            setActiveTourType("customized");
        } else if (type === "group_package_tour") {
            setActiveTourType("package");
        }
        if (type === "customized_tour") setActiveTourTab("customized");
        else if (["all", "group", "customized"].includes(activeTourTab)) setActiveTourTab("all");
    }, [location.search]);

    const filterValues = useMemo(() => {
        const searchData = props.userGroupTourPackageSearchData || {};
        const searchParams = new URLSearchParams(location.search);

        return {
            from: safeTrim(searchData.starting_from),
            to: safeTrim(searchData.going_to),
            search: safeTrim(searchData.search),
            startDate: searchData.start_date
                ? moment(searchData.start_date).format("YYYY-MM-DD")
                : "",
            endDate: searchData.end_date
                ? moment(searchData.end_date).format("YYYY-MM-DD")
                : "",
            tour_type: searchParams.get("tour_type") || "",
            tag: searchParams.get("tag") || searchParams.get("tags") || "",
        };
    }, [props.userGroupTourPackageSearchData, location.search]);

    const isFilterFirstRun = useRef(true);
    const prevFilterValuesRef = useRef(null);

    useEffect(() => {
        if (isFilterFirstRun.current) {
            isFilterFirstRun.current = false;
            prevFilterValuesRef.current = filterValues;
            return;
        }

        setCurrentPage(1);
        updateUrl(1);

        const prev = prevFilterValuesRef.current;
        prevFilterValuesRef.current = filterValues;

        const onlyTagChanged = prev && prev.tag !== filterValues.tag &&
            prev.from === filterValues.from &&
            prev.to === filterValues.to &&
            prev.search === filterValues.search &&
            prev.startDate === filterValues.startDate &&
            prev.endDate === filterValues.endDate &&
            prev.tour_type === filterValues.tour_type;

        if (onlyTagChanged && filterValues.tag) return;

        const timer = setTimeout(() => {
            getGroupTour(1);
        }, 250);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterValues.from,
        filterValues.to,
        filterValues.search,
        filterValues.startDate,
        filterValues.endDate,
        filterValues.tour_type,
        filterValues.tag,
    ]);

    useEffect(() => {
        if (initialLoadRef.current) return;
        updateUrl(currentPage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    const handleGetTourTagCount = (tagParam, freshData = null, onTabUnchanged = null) => {
        if (isTravelClub) {
            const clubFilters = {
                filters: JSON.stringify({ tour_type: "group", tags: ["travel_club"] })
            };
            getTagWiseCount(clubFilters).then((response) => {
                const data = (response?.success && Array.isArray(response.data) ? response.data : []) || [];
                let clubTotal = 0;
                const tabs = TRAVEL_CLUB_TABS.map((t) => {
                    if (t.id === 'all') return t;
                    const match = data.find((item) => item.tag_id === t.id);
                    const count = match ? Number(match.tour_count) || 0 : 0;
                    clubTotal += count;
                    return count > 0 ? { ...t, label: `${t.label} (${count})` } : null;
                }).filter(Boolean);
                tabs[0] = { ...tabs[0], label: `${tabs[0].label} (${response?.all_tour != null ? Number(response.all_tour) || 0 : clubTotal})` };
                setTourTabCountWise(tabs);
                if (onTabUnchanged) onTabUnchanged();
            }).catch(() => {
                setTourTabCountWise(TRAVEL_CLUB_TABS);
                if (onTabUnchanged) onTabUnchanged();
            });
            return;
        }
        const tags = Utility.getTagByKey(selectedTourTag);
        const tag = tagParam || selectedTourTag;
        const TotalTag = [{ id: tags || 'all', label: (tag ? (Utility.getKeyByTags(tag) || tag) : '') || 'All Packages' }];
        const filters = {}
        const searchData = freshData || props.userGroupTourPackageSearchData || {};
        const from = safeTrim(searchData.starting_from);
        let searchObject = {
            "tour_type": activeTourType
        }
        if (tags) {
            if (["domestic", "international"].includes(tags)) {
                searchObject.tag_scope = tags;
                searchObject.tour_scope=tags;
            } else {
                searchObject.tags = [tags];
            }
        }
        if (searchData.start_date) {
            searchObject.start_date = moment(searchData.start_date).format("YYYY-MM-DD")
            if (searchData.end_date) {
                searchObject.end_date = moment(searchData.end_date).format("YYYY-MM-DD")
            }
        }
        if (from) {
            searchObject.location = from;
        }

        const countryParam = searchData.country || new URLSearchParams(location.search).get("country") || "";
        const stateParam = searchData.destination_state || new URLSearchParams(location.search).get("state") || "";
        const cityParam = new URLSearchParams(location.search).get("city") || new URLSearchParams(location.search).get("destination") || "";

        if (countryParam) {
            searchObject.destination_country = [countryParam];
        }

        if (stateParam) {
            searchObject.destination_state = [stateParam];
        }

        if (cityParam) {
            searchObject.destination_city = [cityParam];
        }

        filters['filters'] = JSON.stringify(searchObject)

        const applyTabs = (tabs) => {
            const wantedKey = tag ? Utility.getTagByKey(tag) : '';
            const match = tabs.find((t) =>
                t.id === tag ||
                (wantedKey && t.id === wantedKey) ||
                (tag && String(t.label).replace(/\s*\(\d+\)\s*$/, '') === tag)
            );
            const orderedTabs = match ? [match, ...tabs.filter((t) => t !== match)] : tabs;
            setTourTabCountWise(orderedTabs);
            if (match && tourTabsRef.current) {
                tourTabsRef.current.scrollLeft = 0;
            }
            const nextTabId = match ? match.id : tabs[0].id;
            setActiveTourTab(nextTabId);
            if (nextTabId === activeTourTabRef.current) {
                if (onTabUnchanged) {
                    onTabUnchanged();
                } else {
                    getGroupTour(1, null, [nextTabId]);
                }
            }
        };
        getTagWiseCount(filters).then((response) => {
            const updatedTabs = ((response?.success && response?.data) || [])
                .filter((item) => Number(item.tour_count) > 0)
                .map((item) => ({
                    id: item.tag_id,
                    label: `${item.tag} (${item.tour_count})`,
                }));
            if (["domestic", "international"].includes(tags)) {
                const scopeName = tags === 'domestic' ? 'All Domestic Tours' : 'All International Tours';
                updatedTabs.unshift({ id: 'all', label: scopeName });
            }
            applyTabs(updatedTabs.length ? updatedTabs : TotalTag);
        }).catch((error) => {
            console.log("error=========>", error);
            applyTabs(TotalTag);
        });
    };

    useEffect(() => {
        if (selectedTourTag) {
            handleGetTourTagCount(selectedTourTag);
        }
    }, [selectedTourTag]);

    const isActiveTabFirstRun = useRef(true);

    useEffect(() => {
        if (isActiveTabFirstRun.current) {
            isActiveTabFirstRun.current = false;
            return;
        }
        setCurrentPage(1);
        if (["all", "group", "customized", "all"].includes(activeTourTab)) {
            getGroupTour(1);
            return;
        }
        getGroupTour(1, null, [activeTourTab]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTourTab]);

    const isActiveTourTypeFirstRun = useRef(true);

    useEffect(() => {
        if (isActiveTourTypeFirstRun.current) {
            isActiveTourTypeFirstRun.current = false;
            return;
        }
        // setCurrentPage(1);
        // getGroupTour(1);
        setActiveTourTab("");
        handleGetTourTagCount(selectedTourTag)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTourType]);

    useEffect(() => {
        if (isTagInitialMount.current) {
            isTagInitialMount.current = false;
            return;
        }
        setCurrentPage(1);
        if (selectedDestination || selectedTheme || selectedNavTag) return;
        getGroupTour(1);
    }, [selectedDestination, selectedTheme, selectedNavTag]);

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") closeDepartureModal();
        };

        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, []);

    useEffect(() => {
        if (!departureModalTour) return;
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, [departureModalTour]);

    /* -------------------------------------------------------------------------- */
    /* Sort                                                                       */
    /* -------------------------------------------------------------------------- */

    const visibleTours = useMemo(() => {
        const copy = [...groupTourState];

        if (sortBy === "price-low") {
            return copy.sort((a, b) => Number(getPrice(a)) - Number(getPrice(b)));
        }

        if (sortBy === "price-high") {
            return copy.sort((a, b) => Number(getPrice(b)) - Number(getPrice(a)));
        }

        if (sortBy === "departure") {
            return copy.sort((a, b) => {
                const aDate = getValidDepartures(a)[0]?.start_date;
                const bDate = getValidDepartures(b)[0]?.start_date;

                if (!aDate) return 1;
                if (!bDate) return -1;

                return moment(aDate).valueOf() - moment(bDate).valueOf();
            });
        }

        return copy;
    }, [groupTourState, sortBy, selectedDepartures]);

    /* -------------------------------------------------------------------------- */
    /* Render                                                                     */
    /* -------------------------------------------------------------------------- */

    return (
        <div className="modern-tour-page">
            <div className="modern-tour-shell">
                <section className="modern-search-wrap">
                    <GroupPackageSearchPanel
                        getGroupTour={callGetGroupTour}
                        setGroupTourState={setGroupTourState}
                        callFrom="tour-list"
                        resetSignal={searchResetKey}
                    />
                </section>
                <div className="container">
                    <section className="tour-breadcrumb">
                        <BreadcrumbMenu
                            homeMenuDisplay={true}
                            tourListDisplay={true}
                            activeTourList={true}
                            homeMenuClick={() => history.push(`/${localStorage.getItem('i18nextLng')}/home`)}
                            tourListClick={(e) => {
                                if (e && e.preventDefault) e.preventDefault();
                                setSelectedDestination('');
                                setSelectedTheme('');
                                setSelectedNavTag('');
                                localStorage.removeItem('selectedDestination');
                                if (typeof sessionStorage !== 'undefined') {
                                    sessionStorage.removeItem('selectedDestination');
                                    sessionStorage.removeItem('selectedTheme');
                                    sessionStorage.removeItem('selectedNavTag');
                                }
                                localStorage.removeItem('selectedTheme');
                                localStorage.removeItem('selectedNavTag');
                                setSelectedTourTag('');
                                setTourTabCountWise([{ id: "all", label: "All Packages" }]);
                                setActiveTourTab('all');
                                setCurrentPage(1);
                                setSearchResetKey(k => k + 1);
                                const urlTourType = new URLSearchParams(location.search).get("tour_type");
                                const keptTourType = urlTourType || (activeTourType === 'package' ? 'group_package_tour' : activeTourType === 'customized' ? 'customized_tour' : 'fixed_departure_group_tour');
                                props.groupTourPackageSearchData({ tour_type: keptTourType });
                                history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/tour-list?tour_type=${keptTourType}`);
                            }}
                            tourListLabel={isTravelClub ? "Travel Club" : undefined}
                            tags={isTravelClub ? '' : (() => {
                                const t = selectedTourTag || '';
                                if (!t) return '';
                                const mapped = Utility.getKeyByTags(t);
                                return mapped !== t ? mapped : String(t).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
                            })()}
                        />
                    </section>
                    <nav className="tour-category-bar" aria-label="Tour categories">
                        {/* <button type="button" className="tour-category-filter" onClick={() => document.querySelector(".modern-search-wrap")?.scrollIntoView({ behavior: "smooth", block: "start" })}>
                            Filter <i className="fa fa-angle-double-right" aria-hidden="true" />
                        </button> */}
                        <div className="tour-category-track">
                            <button type="button" className="tour-category-arrow" aria-label="Scroll categories left" onClick={() => scrollTourTabs(-1)}>
                                <i className="fa fa-chevron-left" aria-hidden="true" />
                            </button>
                            <div
                                className={`tour-category-tabs ${isDraggingTabs ? "is-dragging" : ""}`}
                                ref={tourTabsRef}
                                onMouseDown={startTabDrag}
                                onMouseMove={moveTabDrag}
                                onMouseUp={endTabDrag}
                                onMouseLeave={endTabDrag}
                                onClickCapture={handleTabClickCapture}
                            >
                                {tourTabCountWise.map((tab) => (
                                    <button key={tab.id} type="button" className={`tour-category-tab ${activeTourTab === tab.id ? "active" : ""}`} onClick={() => selectTourTab(tab.id)} aria-current={activeTourTab === tab.id ? "page" : undefined}>
                                        {tab.label}{tab.id === "all" && !isTravelClub ? ` (${totalRecords})` : ""}
                                    </button>
                                ))}
                            </div>
                            <button type="button" className="tour-category-arrow" aria-label="Scroll categories right" onClick={() => scrollTourTabs(1)}>
                                <i className="fa fa-chevron-right" aria-hidden="true" />
                            </button>
                        </div>
                    </nav>
                    <section
                        className="modern-tour-hero"
                        ref={tourListTopRef}
                    >
                        <div>
                            <h1>{activeTourType === "group" ? "Fixed Departure Group Tours" : activeTourType === "customized" ? "Customized Tours" : "Package Tours"}</h1>
                            <p>
                                {activeTourType === "group"
                                    ? "Join like-minded travellers on scheduled group departures with memorable experiences and seamless planning."
                                    : activeTourType === "customized"
                                        ? "Get a tour tailored to your pace, preferences and budget with expert planning."
                                        : "Join a package tour and explore the best destinations with expert planning."}
                            </p>
                        </div>
                        <div className="tour-hero-right">
                            <div className="tour-type-toggle" role="group" aria-label="Select tour type">
                                {!isTravelClub && <button type="button" className={activeTourType === "package" ? "active" : ""} aria-pressed={activeTourType === "package"} onClick={() => setActiveTourType("package")}>Package Tours </button>}
                                <button type="button" className={activeTourType === "group" ? "active" : ""} aria-pressed={activeTourType === "group"} onClick={() => setActiveTourType("group")}>Fixed Departure Group Tours</button>
                            </div>
                            <div className="hero-count">
                                Showing <strong>{groupTourState.length}</strong> tours
                            </div>
                        </div>
                    </section>
                </div>
                {isLoading ? (
                    <div className="container">
                        <TourCardSkeleton />
                    </div>
                ) : apiCallFinish && visibleTours.length > 0 ? (
                    <>
                        <div className="container">
                            <div
                                className={`modern-tour-grid ${viewMode === "list" ? "list-view" : ""
                                    }`}
                            >
                                {visibleTours.map((tour) => {
                                    const tourKey = getTourKey(tour);
                                    const imageUrl = getTourImage(tour);
                                    const departures = getValidDepartures(tour);
                                    const selectedDeparture = getSelectedDeparture(tour);
                                    const features = normalizeFeatures(tour);
                                    const nextDeparture =
                                        selectedDeparture?.start_date || tour?.start_date;

                                    const category =
                                        tour?.CategoryData?.category_name ||
                                        tour?.package_category ||
                                        "Tour";

                                    const isPopular =
                                        Number(selectedDeparture?.filling_percentage || 0) >= 50 ||
                                        selectedDeparture?.is_filling_fast;
                                    const totalDepartures = Number(tour?.total_tour || 0);
                                    const hasMultipleDepartures = totalDepartures > 1;

                                    return (
                                        <article className="modern-tour-card" key={tourKey}>
                                            <div className="tour-card-image">
                                                <LazyImage
                                                    src={imageUrl}
                                                    alt={tour?.tour_name || tour?.template_name || "Tour"}
                                                    loaderImage={FALLBACK_IMAGE}
                                                />

                                                <span
                                                    className={`tour-card-badge ${isPopular ? "popular" : ""
                                                        }`}
                                                >
                                                    {isPopular ? "Popular" : category}
                                                </span>

                                                {/* <button
                                                type="button"
                                                className="tour-wishlist"
                                                aria-label="Save tour"
                                                onClick={(event) => event.stopPropagation()}
                                            >
                                                <i className="fa fa-heart-o" />
                                            </button> */}

                                                <span className="tour-duration">{getDuration(tour)}</span>

                                                {hasMultipleDepartures && (
                                                    <button
                                                        type="button"
                                                        className="tour-departure-count"
                                                        onClick={() => openDepartureModal(tour)}
                                                    >
                                                        <i className="fa fa-calendar-o" />
                                                        {totalDepartures} departures available
                                                    </button>
                                                )}
                                            </div>

                                            <div className="tour-card-body">
                                                <div className="tour-card-heading">
                                                    <h3 title={tour?.tour_name || tour?.template_name}>
                                                        {tour?.tour_name ||
                                                            tour?.template_name ||
                                                            "Tour Package"}
                                                    </h3>

                                                    {/* <div className="tour-rating-row">
                                                    <span className="tour-rating">
                                                        <i className="fa fa-star" /> 4.6
                                                    </span>
                                                    <span className="tour-rating-note">
                                                        Curated tour experience
                                                    </span>
                                                </div> */}
                                                </div>

                                                <div className="tour-feature-row">
                                                    {features.map((feature) => (
                                                        <span key={feature.label}>
                                                            <i className={`fa ${feature.icon}`} />
                                                            {feature.label}
                                                        </span>
                                                    ))}
                                                </div>

                                                <div className="tour-card-bottom">
                                                    <div className="tour-next-date">
                                                        <small>
                                                            {hasMultipleDepartures
                                                                ? "Upcoming Departure"
                                                                : "Departure"}
                                                        </small>

                                                        <strong>
                                                            <i className="fa fa-calendar-o" />
                                                            {nextDeparture
                                                                ? moment(nextDeparture).format("DD MMM YYYY")
                                                                : "Flexible Date"}
                                                        </strong>

                                                        {hasMultipleDepartures && (
                                                            <button
                                                                type="button"
                                                                className="change-date-link"
                                                                onClick={() => openDepartureModal(tour)}
                                                            >
                                                                View all dates
                                                            </button>
                                                        )}
                                                    </div>

                                                    <div className="tour-price">
                                                        <small>From</small>
                                                        <strong>{formatPrice(tour)}</strong>
                                                        <span>per person</span>
                                                    </div>
                                                </div>

                                                <div className={`tour-card-actions ${hasMultipleDepartures ? '' : 'single-action'}`}>
                                                    <button
                                                        type="button"
                                                        className={`tour-btn tour-btn-outline ${hasMultipleDepartures ? '' : 'tour-btn-full'}`}
                                                        onClick={() => goToTourDetails(tour)}
                                                    >
                                                        View Details
                                                    </button>

                                                    {hasMultipleDepartures && (
                                                        <button
                                                            type="button"
                                                            className="tour-btn tour-btn-primary"
                                                            onClick={() => openDepartureModal(tour)}
                                                        >
                                                            Choose Date
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </article>
                                    );
                                })}
                            </div>
                        </div>
                        {totalPages > 1 && (
                            <div className="container">
                                <div className="modern-pagination">
                                    <button
                                        type="button"
                                        className="pagination-arrow"
                                        disabled={currentPage <= 1}
                                        onClick={() => {
                                            const page = Math.max(1, currentPage - 1);
                                            setCurrentPage(page);
                                            getGroupTour(page);
                                            scrollToTourListTop();
                                        }}
                                    >
                                        <i className="fa fa-angle-left" />
                                    </button>

                                    {Array.from({ length: totalPages }, (_, index) => index + 1)
                                        .filter(
                                            (page) =>
                                                page === 1 ||
                                                page === totalPages ||
                                                Math.abs(page - currentPage) <= 1
                                        )
                                        .reduce((acc, page, index, pages) => {
                                            if (index > 0 && page - pages[index - 1] > 1) {
                                                acc.push(
                                                    <span
                                                        className="pagination-ellipsis"
                                                        key={`ellipsis-${page}`}
                                                    >
                                                        ...
                                                    </span>
                                                );
                                            }

                                            acc.push(
                                                <button
                                                    type="button"
                                                    key={page}
                                                    className={currentPage === page ? "active" : ""}
                                                    onClick={() => {
                                                        setCurrentPage(page);
                                                        getGroupTour(page);
                                                        scrollToTourListTop();
                                                    }}
                                                >
                                                    {page}
                                                </button>
                                            );

                                            return acc;
                                        }, [])}

                                    <button
                                        type="button"
                                        className="pagination-arrow"
                                        disabled={currentPage >= totalPages}
                                        onClick={() => {
                                            const page = Math.min(totalPages, currentPage + 1);
                                            setCurrentPage(page);
                                            getGroupTour(page);
                                            scrollToTourListTop();
                                        }}
                                    >
                                        <i className="fa fa-angle-right" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="container">
                        <div className="modern-tour-empty">
                            <span>
                                <i className="fa fa-map-o" />
                            </span>
                            <h3>No tours found</h3>
                            <p>Try changing your destination or travel dates.</p>
                        </div>
                    </div>
                )}
            </div>

            {departureModalTour && (
                <div
                    className="departure-modal-backdrop"
                    role="presentation"
                    onMouseDown={(event) => {
                        if (event.target === event.currentTarget) closeDepartureModal();
                    }}
                >
                    <div
                        className="departure-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="departure-modal-title"
                    >
                        <div className="departure-modal-header">
                            <div>
                                <span className="departure-modal-kicker">
                                    Select your travel date
                                </span>
                                <h3 id="departure-modal-title">
                                    Choose Departure Date
                                </h3>
                                <p>
                                    {departureModalTour?.DestinationFrom?.destination_name ||
                                        "Origin"}
                                    <i className="fa fa-long-arrow-right" />
                                    {departureModalTour?.DestinationTo?.destination_name ||
                                        departureModalTour?.tour_name ||
                                        "Destination"}
                                    <span>•</span>
                                    {getDuration(departureModalTour)}
                                </p>
                            </div>

                            <button
                                type="button"
                                className="departure-modal-close"
                                onClick={closeDepartureModal}
                                aria-label="Close"
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        <div className="departure-modal-list">
                            {isLoadingDepartures ? (
                                <DepartureModalSkeleton />
                            ) : modalDepartures.length === 0 ? (
                                <div className="departure-modal-empty">
                                    No departures available.
                                </div>
                            ) : (
                                modalDepartures.map((departure) => {
                                    const departureKey = departure.id || departure.tour_code;
                                    const isSelected =
                                        String(departure.id) ===
                                        String(modalSelectedDepartureId) ||
                                        String(departure.tour_code) ===
                                        String(modalSelectedDepartureId);
                                    const isPast = isPastDeparture(departure);
                                    const isDisabled = departure.is_sold_out || isPast;

                                    const availability = getAvailability(departure);
                                    const symbol = Utility.getCurrencySymbol(
                                        departure?.branch_details?.currency ||
                                        departureModalTour?.branch_details?.currency ||
                                        departure?.base_currency ||
                                        "INR"
                                    );

                                    const price = Number(
                                        departure?.price_for_adult ||
                                        departure?.final_selling_price ||
                                        0
                                    );

                                    return (
                                        <div
                                            className={`departure-option ${isSelected ? "selected" : ""
                                                } ${isDisabled ? "disabled" : ""}`}
                                            key={departureKey}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (!isDisabled) {
                                                    setModalSelectedDepartureId(departureKey);
                                                }
                                            }}
                                        >
                                            <input
                                                type="radio"
                                                name="tour-departure"
                                                value={departureKey}
                                                checked={isSelected}
                                                disabled={isDisabled}
                                                onChange={() => {
                                                    if (!isDisabled) {
                                                        setModalSelectedDepartureId(departureKey);
                                                    }
                                                }}
                                            />

                                            <span className="custom-radio" />

                                            <span className="departure-date-info">
                                                <strong>
                                                    {moment(departure.start_date).format("DD MMM")} -{" "}
                                                    {moment(departure.end_date).format("DD MMM YYYY")}
                                                </strong>
                                                <small>
                                                    {departure.tour_code ? `${departure.tour_code} • ` : ""}
                                                    {departure.duration ||
                                                        `${departure.duration_nights || 0} Nights / ${departure.duration_days || 0
                                                        } Days`}
                                                </small>
                                            </span>

                                            <span className="departure-option-price">
                                                <strong>
                                                    {symbol}
                                                    {price.toLocaleString("en-IN", {
                                                        maximumFractionDigits: 0,
                                                    })}
                                                </strong>
                                                <small>per person</small>
                                            </span>

                                            <span
                                                className={`departure-status ${availability.className}`}
                                            >
                                                {availability.label}
                                            </span>
                                        </div>
                                    );
                                })
                            )}
                        </div>

                        <div className="departure-modal-footer">
                            <div className="modal-help-text">
                                <i className="fa fa-info-circle" />
                                Select a departure to view its exact availability and tour
                                details.
                            </div>

                            <button
                                type="button"
                                className="departure-continue"
                                onClick={continueWithSelectedDeparture}
                                disabled={!modalSelectedDepartureId}
                            >
                                Continue
                                <i className="fa fa-arrow-right" />
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (globalState) => ({
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token,
    tourSearchDataFromReducer: globalState.mainReducerData.tourSearchData,
    userGroupTourPackageSearchData:
        globalState.mainReducerData.groupTourPackageSearchData,
    selectedNavTagFromReducer: globalState.mainReducerData?.selectedNavTag,
    userHotelGroupPackageSelectedData: globalState.mainReducerData.hotelGroupPackageSelectedData,
});

export default connect(mapStateToProps, {
    loaderStateTrue,
    loaderStateFalse,
    tourSearchData,
    groupTourPackageSearchData,
})(withNamespaces()(TourList));